/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
 @angular-eslint/no-inputs-metadata-property,
*/

import { Component, ChangeDetectionStrategy } from '@angular/core';

import type { IconToken } from '@core/user-interface-legacy';
import { IconComponent } from '@core/user-interface-legacy';

@Component({
  imports: [IconComponent],
  selector: 'rt-priority-cell',
  template: `
    <rt-icon [name]="'flag'" [colorToken]="priority.iconColorToken" margin-right-small />
    <span>{{ priority.label }}</span>
  `,
  styleUrls: ['./priority-cell.component.less'],
  host: {
    '[class]': '"priority"',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  inputs: PriorityCellComponent.NgInputs,
})
export class PriorityCellComponent {
  public static NgInputs = ['priority' as const];

  public priority: { iconColorToken: IconToken; label: string };
}
